export interface HeroSlide {
  movieId: string;
  backdrop: string;
  tagline: string;
}

export const heroSlides: HeroSlide[] = [
  {
    movieId: "interstellar-dawn",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20deep%20navy%20space%20scene%20with%20a%20lone%20spaceship%20silhouette%20before%20a%20giant%20golden%20nebula%2C%20dramatic%20cinematic%20lighting%2C%20dark%20tones%20for%20text%20contrast%2C%20wide%20film%20still%2C%20no%20text&width=1600&height=900&seq=ttc-hero-01&orientation=landscape",
    tagline: "穿越从未抵达的星域，寻找人类最后的黎明",
  },
  {
    movieId: "fog-city",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20grey%20foggy%20city%20skyline%20at%20dawn%20with%20a%20lone%20bridge%20silhouette%2C%20cold%20desaturated%20blue%20tones%2C%20mysterious%20cinematic%20atmosphere%2C%20dark%20for%20text%20contrast%2C%20wide%20film%20still%2C%20no%20text&width=1600&height=900&seq=ttc-hero-02&orientation=landscape",
    tagline: "浓雾之下，每一桩失踪案都指向同一个传说",
  },
  {
    movieId: "changan-night",
    backdrop:
      "https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20city%20at%20night%20with%20countless%20glowing%20red%20lanterns%20lining%20long%20streets%2C%20warm%20amber%20and%20deep%20indigo%20tones%2C%20cinematic%20epic%20scale%2C%20dark%20for%20text%20contrast%2C%20wide%20film%20still%2C%20no%20text&width=1600&height=900&seq=ttc-hero-03&orientation=landscape",
    tagline: "长安灯火不眠，一桩悬案揭开尘封十年的旧事",
  },
  {
    movieId: "mecha-awake",
    backdrop:
      "https://readdy.ai/api/search-image?query=Giant%20humanoid%20mecha%20standing%20in%20a%20destroyed%20futuristic%20city%20with%20glowing%20orange%20core%2C%20steel%20grey%20and%20amber%20tones%2C%20intense%20cinematic%20lighting%2C%20dark%20for%20text%20contrast%2C%20wide%20film%20still%2C%20no%20text&width=1600&height=900&seq=ttc-hero-04&orientation=landscape",
    tagline: "当机器拥有意识，谁才是真正的「人」",
  },
  {
    movieId: "jiangnan-past",
    backdrop:
      "https://readdy.ai/api/search-image?query=Serene%20Chinese%20water%20town%20along%20a%20canal%20with%20stone%20bridges%20and%20warm%20evening%20lanterns%2C%20muted%20jade%20green%20and%20amber%20tones%2C%20nostalgic%20cinematic%20mood%2C%20dark%20for%20text%20contrast%2C%20wide%20film%20still%2C%20no%20text&width=1600&height=900&seq=ttc-hero-05&orientation=landscape",
    tagline: "一匹丝绸，织出江南水乡的百年记忆",
  },
];

export const categoryCards = {
  movie: {
    title: "电影",
    count: "14,000+ 部",
    desc: "动作、科幻、悬疑、爱情…海量院线新片与经典佳作",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20interior%20with%20rows%20of%20empty%20red%20seats%20and%20a%20glowing%20blank%20screen%2C%20deep%20navy%20and%20crimson%20tones%2C%20moody%20atmospheric%20lighting%2C%20no%20text&width=1200&height=800&seq=ttc-cat-movie&orientation=landscape",
  },
  tv: {
    title: "电视剧",
    count: "8,600+ 部",
    desc: "国产剧、美剧、韩剧、日剧…热播剧集一网打尽",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20dark%20living%20room%20at%20night%20with%20a%20large%20TV%20screen%20glowing%20and%20soft%20lamplight%2C%20teal%20and%20warm%20amber%20tones%2C%20comfortable%20binge-watching%20atmosphere%2C%20no%20text&width=1200&height=800&seq=ttc-cat-tv&orientation=landscape",
  },
};